import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Tray } from "@phosphor-icons/react";
import api from "@/lib/api";
import { InboxFilters } from "@/components/inbox/InboxFilters";
import { InboxRow } from "@/components/inbox/InboxRow";
import { BuyerSetupCheck } from "@/components/inbox/BuyerSetupCheck";

export default function RequestInbox() {
  const [status, setStatus] = useState("pending");
  const [type, setType] = useState("all");
  const [buyer, setBuyer] = useState("");
  const [data, setData] = useState(null);
  const load = useCallback(() => {
    api.get("/admin/request-inbox", { params: { status, type } })
      .then((r) => setData(r.data))
      .catch(() => setData({ items: [], pending: {}, types: [], failed: true }));
  }, [status, type]);
  useEffect(() => { load(); }, [load]);
  const buyers = useMemo(() => [...new Set((data?.items || []).map((i) => i.buyer))].sort(), [data]);
  const items = (data?.items || []).filter((i) => !buyer || i.buyer === buyer);
  const waiting = Object.values(data?.pending || {}).reduce((a, b) => a + b, 0);
  return (
    <div data-testid="request-inbox-page">
      <div className="mb-6 flex flex-wrap items-end gap-4">
        <div className="mr-auto">
          <div className="label-mono">Buyers</div>
          <h1 className="font-chivo text-4xl font-black uppercase leading-none tracking-tighter md:text-5xl">Request inbox</h1>
          <p className="mt-2 max-w-xl text-sm text-zinc-600">Every change a buyer asks for, in one place. Approve or turn each one down with one click; the buyer is emailed like before.</p>
        </div>
        <div className="flex items-center gap-2 border-2 border-black bg-amber-300 px-3 py-2" data-testid="inbox-waiting-count">
          <Tray size={18} weight="bold" />
          <span className="font-chivo text-2xl font-black leading-none">{data ? waiting : "…"}</span>
          <span className="text-[10px] uppercase tracking-widest">waiting</span>
        </div>
      </div>
      <InboxFilters data={data} type={type} onType={(v) => { setType(v); setBuyer(""); }}
                    status={status} onStatus={(v) => { setStatus(v); setBuyer(""); }}
                    buyer={buyer} onBuyer={setBuyer} buyers={buyers} />
      <div className="border-2 border-black bg-white shadow-[4px_4px_0_0_#000]" data-testid="inbox-list">
        {!data && <div className="p-6 label-mono">Loading…</div>}
        {data?.failed && <div className="p-6 text-sm text-rose-700" data-testid="inbox-error">Couldn't load the requests. Refresh to try again.</div>}
        {items.map((i) => <InboxRow key={`${i.source}-${i.id}`} item={i} onDone={load} />)}
        {data && !data.failed && !items.length && (
          <div className="p-8 text-center text-sm text-zinc-600" data-testid="inbox-empty">
            {status === "pending" ? "Nothing waiting. You're all caught up." : "No requests match these filters."}
          </div>
        )}
      </div>
      <BuyerSetupCheck />
    </div>
  );
}
